import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useCallback } from 'react'
import { useTheme } from 'styled-components'

import { Padding } from '../../layout'
import { Span } from '../../typography/Body'
import { StButton } from './Button.styled'

import type { MouseEvent } from 'react'
import type { ButtonProps } from './Button.types'

const Button = ({
  children,
  inline = false,
  isLoading,
  noWrap,
  prefixIcon,
  size = 'normal',
  suffixIcon,
  style,
  variant,
  ...inheritedProps
}: ButtonProps) => {
  const theme = useTheme()
  const isSmall = size === 'small'

  // Interaction methods
  // ------------------------------------------------------------------------- /
  const handleClick = useCallback(
    (event: MouseEvent<HTMLButtonElement>) => {
      if (!isLoading && inheritedProps.onClick) {
        inheritedProps.onClick(event)
      }
    },
    [inheritedProps.onClick, isLoading],
  )

  return (
    <StButton
      role='button'
      inline={inline}
      size={size}
      variant={variant}
      {...inheritedProps}
      onClick={handleClick}
      noWrap={noWrap}
      style={{ minWidth: 120, ...style }}
    >
      {isLoading ? (
        <FontAwesomeIcon spin icon={['fad', 'loader']} />
      ) : (
        <>
          {prefixIcon ? (
            <Padding pr={theme.UI.Spacing.Space3}>
              <FontAwesomeIcon icon={prefixIcon} />
            </Padding>
          ) : null}
          <Span
            type={isSmall ? 'BodySmallBold' : 'BodyMediumBold'}
            style={{
              fontWeight: variant === 'Grey' ? 400 : 600,
            }}
          >
            {children}
          </Span>
          {suffixIcon ? (
            <Padding pl={theme.UI.Spacing.Space2}>
              <FontAwesomeIcon icon={suffixIcon} />
            </Padding>
          ) : null}
        </>
      )}
    </StButton>
  )
}

export { Button }
